import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    // 初期状態でモバイルメニューを閉じる
    this.close()
  }

  toggle() {
    if (this.menuTarget.classList.contains('translate-x-0')) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    // サイドバーを表示
    this.menuTarget.classList.remove('-translate-x-full')
    this.menuTarget.classList.add('translate-x-0')

    // オーバーレイを表示
    const overlay = document.getElementById('sidebar-overlay')
    if (overlay) {
      overlay.classList.remove('hidden')
    }
  }

  close() {
    // サイドバーを非表示
    this.menuTarget.classList.remove('translate-x-0')
    this.menuTarget.classList.add('-translate-x-full')

    // オーバーレイを非表示
    const overlay = document.getElementById('sidebar-overlay')
    if (overlay) {
      overlay.classList.add('hidden')
    }
  }
}
